export default {
      id: "ic_filter_active-usage",
      viewBox: "0 0 27 18",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_active-usage",
      toString: function () {
        return this.url;
      }
    }